import * as React from 'react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { ComplianceStore } from '../../ComplianceStore'
import { Button, message } from 'antd'
import { Track } from '../../../../../../Track'
import { parseErrorMsg } from '../../../../../../utilities/helpers'
import { ManitobaFederalReport } from './ManitobaFederalReport'
import { MBComplianceApi, MBComplianceModels } from '@getgreenline/compliance'
import { TMBComplianceReportRequestContract } from '@getgreenline/compliance/build/models/MBComplianceModels'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  complianceStore: ComplianceStore
}

interface State {
  isLoading: boolean
}

export class Manitoba extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isLoading: false,
    }
  }

  generate = async () => {
    const { month, year, locationIds, timeFrame } = this.props.complianceStore
    const params: TMBComplianceReportRequestContract<MBComplianceModels.MBReportType.LGCA> = {
      month: month,
      year: year,
      locationIds: locationIds,
      reportType: MBComplianceModels.MBReportType.LGCA,
      timeFrame: timeFrame,
    }

    Track.track('dashboard:compliance_complianceReportGenerated', params)
    const company = this.props.currentCompanyStore!.company!
    this.setState({ isLoading: true })

    try {
      const response = await MBComplianceApi.getMBComplianceReport(company.id, params)
      const blob = new Blob([response])
      const a = window.document.createElement('a')
      a.href = (window.URL as any).createObjectURL(blob, { type: 'text/plain' } as any)
      a.download = this.props.complianceStore.generateFileName(company.name, 'csv')
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } catch (err) {
      message.error(parseErrorMsg(err) || 'Error generating MB compliance report')
    } finally {
      this.setState({ isLoading: false })
    }
  }

  render() {
    const { isLoading } = this.state
    const { locationIds } = this.props.complianceStore

    return (
      <div>
        <div>
          <ManitobaFederalReport complianceStore={this.props.complianceStore} />
        </div>
        <div style={{ height: 50 }} />
        <div>
          <h5>LGCA report</h5>
          <Button
            type='primary'
            onClick={() => this.generate()}
            loading={locationIds.length === 0 || isLoading}
          >
            {isLoading
              ? 'Downloading...'
              : `Download LGCA ${this.props.complianceStore.timeFrame} report`}
          </Button>
        </div>
      </div>
    )
  }
}
